import { ColumnStartOrder, ColumnName, ColumnNoc, ColumnResult, ColumnExpander, ColumnRank, ColumnQualification } from "components/common/TableColumns"
import Label from "components/general/Label"
import { findArray } from 'helpers/utils'


export function ColumnExercise({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-15',
    remove = false,
    number,
    routine
}) {
    return (
        {
            Header: <Label data={`HeaderExercise${number}`} sport='GTR' />,
            remove: remove,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: `Exercise${number}`,
            accessor: (props) => {
                let value = findArray(props.extendedResults, { er_code: ['ROUTINE'], er_pos: [number] }).er_value
                return value
            },
            Cell: (props) => {
                let exercise = findArray(props.cell.row.original.extendedResults, { er_code: ['ROUTINE'], er_pos: [number] })
                let isIrm = exercise?.er_irm
                if(isIrm)
                    return exercise?.er_irm
                let value = exercise?.er_value
                let isBest = exercise?.er_value2 === 'BEST'
                let inquiry = findArray(exercise.extensions, { ere_code: ['INQUIRY'] }) ? '*' : ''
                return <span className={isBest && routine === '2' ? 'fw-bold' : ''}>{inquiry}{value}</span>
            }
        }
    )
}

export function TableColumnsStartList(routine) {
    return (
        [
            ColumnStartOrder({ label: "LabelStartOrderN" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnExercise({ number: '1', routine }),
            ColumnExercise({ number: '2', routine }),
            ColumnResult({ label: "HeaderBestScore" }),
        ]
    )
}

export function TableColumnsLive(routine) {
    return (
        [
            ColumnRank({}),
            ColumnStartOrder({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnExercise({ number: '1', routine }),
            ColumnExercise({ number: '2', routine }),
            ColumnResult({ label: "HeaderBestScore" }),
            ColumnQualification({ className: 'text-end fw-bold' }),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsStartListSM() {
    return (
        [
            ColumnStartOrder({ label: "LabelStartOrderN", disableSort: true }),
            ColumnNoc({}),
            ColumnName({ disableSort: true }),
            ColumnResult({ label: "HeaderBestScore" }),
        ]
    )
}

export function TableColumnsLiveSM() {
    return (
        [
            ColumnRank({ disableSort: true }),
            ColumnNoc({}),
            ColumnName({ disableSort: true }),
            ColumnResult({ label: "HeaderBestScore" }),
            ColumnQualification({ className: 'text-end fw-bold' }),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsStartListFNL() {
    return (
        [
            ColumnStartOrder({ label: "LabelStartOrderN" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "HeaderScore" }),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsLiveFNL() {
    return (
        [
            ColumnRank({}),
            ColumnStartOrder({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "HeaderScore" }),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsStartListFNL_SM() {
    return (
        [
            ColumnStartOrder({ label: "LabelStartOrderN", disableSort: true }),
            ColumnNoc({}),
            ColumnName({ disableSort: true }),
            ColumnResult({ label: "HeaderScore" }),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsLiveFNL_SM() {
    return (
        [
            ColumnRank({ disableSort: true }),
            ColumnNoc({}),
            ColumnName({ disableSort: true }),
            ColumnResult({ label: "HeaderScore" }),
            ColumnExpander({})
        ]
    )
}





